export var getWidth = function getWidth(element) {
  return element ? element.getBoundingClientRect().width : 0;
};